// @ts-nocheck

import qs from 'query-string';
import CommonApi from './../commonApi';
import { fetchRequest } from './index';
const pddQuestion = new CommonApi('pddQuestion', 'Вопросы ПДД');
export const getAllQuestionsId = async () => {
  const data = await fetchRequest.get(`/pddQuestion/getAllQuestionsId`);
  if (data) return data;
  throw new Error('Не удалось получить вопросы для тестирования!');
};
export const getAdditionalQuestions = async (groupIds, pddTestId, ppdQuestionIds) => {
  const data = await fetchRequest.get(`/pddQuestion/getAdditionalQuestions?${qs.stringify({
    groupIds,
    pddTestId,
    ppdQuestionIds
  }, {
    arrayFormat: 'index'
  })}`);
  if (data) return data;
  throw new Error('Не удалось получить вопросы для тестирования!');
};
export default {
  ...pddQuestion,
  getAllQuestionsId,
  getAdditionalQuestions
};
